import { C, F, Card, SectionHead } from '../../../tokens';

// Placeholder shell — five learning surfaces, no data or logic yet.
const PANELS = [
  { title:"Understanding Score",  desc:"How completely Compass understands this business — grows as identity, goals, and data fill in." },
  { title:"Pending Questions",    desc:"Open questions Compass needs answered to sharpen its picture of the business." },
  { title:"Suggested Updates",    desc:"Changes Compass proposes to keep the business model current as new signals arrive." },
  { title:"Learning Timeline",    desc:"A running history of what Compass has learned and when." },
  { title:"Confidence",           desc:"How sure Compass is about what it currently believes, area by area." },
];

export default function LearningTab() {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <SectionHead title="Learning" sub="How Compass builds and refines its understanding of this business over time." />
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {PANELS.map(p=>(
          <Card key={p.title} style={{padding:"18px 20px"}}>
            <div style={{fontFamily:F.display,fontSize:15,color:C.charcoal,fontWeight:600,marginBottom:4}}>{p.title}</div>
            <div style={{fontFamily:F.body,fontSize:12,color:C.charMid,lineHeight:1.5}}>{p.desc}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
